import React from 'react';
import { Card } from '../ui/card';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { ROLE_COLORS } from './adminConstants';

const UserRow = ({ u, onSelect, onDelete }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', padding: '0.75rem 1rem', borderRadius: 10, border: '1px solid #ECE7DE', background: '#FAFBFC' }} className="candidate-row">
    <div style={{ width: 36, height: 36, borderRadius: '50%', background: `linear-gradient(135deg, ${ROLE_COLORS[u.role] || '#0076A3'}, ${ROLE_COLORS[u.role] || '#0076A3'}80)`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.8125rem', fontWeight: 600, color: '#fff' }}>
      {u.name?.charAt(0)?.toUpperCase()}
    </div>
    <div style={{ flex: 1, minWidth: 0, cursor: 'pointer' }} onClick={() => onSelect(u)}>
      <div style={{ fontSize: '0.875rem', fontWeight: 600, color: '#0076A3' }}>
        {u.name}
        {u.is_super_admin && <span style={{ marginLeft: 6, fontSize: '0.5625rem', padding: '0.0625rem 0.375rem', borderRadius: 999, background: '#FEF2F2', color: '#DC2626', fontWeight: 700 }}>SUPER ADMIN</span>}
      </div>
      <div style={{ fontSize: '0.6875rem', color: '#64748B' }}>{u.email}</div>
      {(u.first_name || u.last_name || u.location) && (
        <div style={{ fontSize: '0.625rem', color: '#94A3B8' }}>
          {[u.first_name, u.last_name].filter(Boolean).join(' ')}
          {u.location && ` · ${u.location}`}
        </div>
      )}
    </div>
    <Badge style={{ background: `${ROLE_COLORS[u.role] || '#64748B'}15`, color: ROLE_COLORS[u.role] || '#64748B', border: 'none', borderRadius: 999, fontSize: '0.6875rem', textTransform: 'capitalize' }}>{u.role?.replace('_', ' ')}</Badge>
    <div style={{ display: 'flex', gap: '0.375rem' }}>
      <Button variant="outline" onClick={() => onSelect(u)} style={{ borderRadius: 8, fontSize: '0.6875rem', padding: '0.3125rem 0.625rem' }}>View</Button>
      {!u.is_super_admin && (
        <Button variant="outline" onClick={() => onDelete(u._id, u.name)} style={{ borderRadius: 8, fontSize: '0.6875rem', padding: '0.3125rem 0.625rem', borderColor: '#FECACA', color: '#DC2626' }}>Delete</Button>
      )}
    </div>
  </div>
);

export const AdminUsersTab = ({ users, onSelect, onDelete }) => (
  <Card style={{ background: '#fff', border: '1px solid #ECE7DE', borderRadius: 14, padding: '1.5rem' }}>
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
      {users.map(u => (
        <UserRow key={u._id} u={u} onSelect={onSelect} onDelete={onDelete} />
      ))}
    </div>
  </Card>
);
